// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"bb9a2404","132":"5d04ab5f","785":"020462c0","849":"b9b70218"}[chunkId] + ".js";
};